import * as React from "react";
import {Link, Trans} from "gatsby-plugin-react-i18next";

const Header = () => {
	return (
		<div className="w-full header-bg">
			<div className="max-w-6xl mx-auto px-6 py-20">
				<div className="max-w-md pt-10 md:pt-20">
					<h1 className=" text-3xl md:text-5xl text-white uppercase font-extrabold pb-3 md:pb-6">
						<Trans>Odania - to protect the universe</Trans>
					</h1>
					<p className=" text-sm md:text-base text-white pb-10">
						<Trans>Gaming & more</Trans>
					</p>
					<div className="flex flex-col md:flex-row">
						<Link
							to="/contact-us"
							className="text-white border text-center w-full border-white font-semibold rounded-md px-12 cursor-pointer transition-all hover:bg-blueish hover:border-blueish py-3 mx-auto mb-4 md:mb-0 md:mr-4"
						>
							<Trans>Contact us</Trans>
						</Link>

						<Link
							to="/pages/projects"
							className="text-white  w-full text-center font-semibold bg-blueish border border-blueish rounded-md px-12 py-3 cursor-pointer transition-all hover:bg-transparent hover:border-white"
						>
							<Trans>Play games</Trans>
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Header;
